import React from "react";
import { Box, Typography, Container } from "@mui/material";

const PrivacyPolicy = () => {
  const policySections = [
    {
      title: "Scope of Policy",
      content: `This privacy policy (Policy) together with our Terms of Use and Loan Account Agreement
            applies to your use of:
            1. Sava Loan and Sava Ambassador mobile application software (App) available on our site or hosted on the Google Play Store.
            2. Any of the services accessible through the App or other sites.`,
    },
    {
      title: "Information We May Collect From You",
      content: `We may collect and process the following data about you:
            i. Information you give us about you (Submitted information)
            ii. Information we collect about you and your device
            iii. Location information
            iv. Information we receive from other sources (Third Party Information)
            v. Unique application numbers
            vi. Third-Party Social Media data`,
    },
    {
      title: "Tracking and Cookies",
      content:
        "We may use mobile tracking technologies and/or website cookies to distinguish you from other users of the App, App Site, or Service Sites.",
    },
    {
      title: "Uses Made of the Information",
      content: `We may use the collected information to determine loan eligibility, loan amounts, terms, and other related purposes. Aggregated and anonymized data may also be shared for reporting purposes.`,
    },
    {
      title: "Disclosure of Your Information",
      content: `We may disclose your personal information to third parties under certain circumstances, such as legal obligations or business transactions.`,
    },
    {
      title: "Where We Store Your Personal Data",
      content: `Your data may be stored or processed outside Tanzania. While we strive to protect your data, transmission via the internet carries risks. By using our services, you consent to the collection, transfer, and processing of your data as outlined.`,
    },
    {
      title: "Google API Disclosure",
      content: `Sava’s use of information received from Google APIs adheres to Google API Services User Data Policy, including Limited Use requirements.`,
    },
    {
      title: "Changes to Privacy Policy",
      content: `Changes to this Policy will be posted on this page. By continuing to use the App or Services, you confirm your acceptance of the updated terms.`,
    },
    {
      title: "Contact Us",
      content: `If you have any questions, you can contact us via email: info@sava.co.tz, phone: +255 672 600 151, or by visiting our website: https://sava.co.tz/privacy-policy`,
    },
  ];
  return (
    <Container
      maxwidth={false}
      sx={{
        maxwidth: "1300px",
        marginTop: { xs: "0px", sm: "80px", lg: "50px" },
        marginBottom: { xs: "5px", sm: "80px", lg: "0px" },
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column", // Ensure vertical stacking on smaller screens
          justifyContent: "center", // Center content vertically
          padding: { xs: "0px", sm: "20px" },
          marginBottom: { xs: "0px", md: "0px" },
        }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: "bold", textAlign: "center" }}>
          Privacy Policy
        </Typography>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            Summary
          </Typography>
          <Typography variant="body1">
            SAVA-TECH FINANCIAL SERVICES LIMITED (“SAVA”) is a limited liability
            company incorporated under the laws of United Republic of Tanzania
            with a registration number 164481298. Sava takes your privacy very
            seriously. This Privacy Policy explains what personal information we
            collect about you, with whom we share it with, and how you (the user
            of the Service) can prevent us from sharing certain information with
            certain parties. ” Personal Information ” refers to information that
            can be used to identify an individual. You should read this Privacy
            Policy in its entirety.
          </Typography>
        </Box>

        <Box>
          <Typography>Scope of policy</Typography>
          <Typography>
            This privacy policy (Policy) together with our Terms of Use and Loan
            Account Agreement as set out by sava and any additional terms of use
            applies to your use of:
          </Typography>

          <Typography>
            1. Sava Loan and Sava Ambassador mobile application software (App)
            available on our site OR hosted on the Google Play Store (App Site),
            once you have downloaded or streamed a copy of the App onto your
            mobile telephone or handheld device (Device).
            <Typography>
              2. Any of the services accessible through the App (Services) or
              those available on the App Site or other sites of ours or other
              third-party Sites (Service Sites). This policy sets out the basis
              on which any personal data we collect from you, or that you
              provide to us, will be processed by us.
            </Typography>
            <Box sx={{ marginTop: "10px" }}>
              <Typography variant="body">
                Please read the following carefully to understand our views and
                practices regarding your personal data and how we will treat it.
                By downloading the App, you confirm that you have read,
                understood and accept the terms of this Policy set out
                hereunder. You also consent to the collection, use, storage,
                processing and disclosure of your personal information in the
                manner set out in this Policy.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                A. Information we may collect from you
              </Typography>

              <Typography>
                We may collect and process the following data about you.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                i. Informtion you give us about you (submitted information)
              </Typography>

              <Typography>This may include inforamtion:</Typography>

              <Typography>
                <ul>
                  <li>
                    provided by filling in forms in the App or on the App Site
                    (together Our Sites);
                  </li>
                  <li>
                    provided by corresponding with us (for example, by e-mail or
                    chat);
                  </li>
                  <li>
                    provided by registering to use the App Site, downloading or
                    registering the App,subscribing to any of our Services (such
                    as applying for a loan), searching for an app or Service,
                    sharing data via the App’s social media functions, entering
                    a competition, promotion or survey, and reporting a problem
                    with the App, our Services, our App Site or any of Our
                    Service Sites.
                  </li>
                </ul>
                This information may include your name, address, e-mail address
                and phone number, the Device’s phone number, SIM card details,
                age, username, password, geo-location and other registration
                information, financial and credit information (including your
                mobile money account details where applicable), personal
                description and photograph.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                ii. Information we collect about you and your device
              </Typography>

              <Typography>
                Each time you visit one of our Sites or use one of our Apps we
                may automatically collect the following information:
              </Typography>

              <Typography>
                <ul>
                  <li>
                    technical information, including the type of mobile device
                    you use, unique device identifiers (for example, your
                    Device’s IMEI or serial number), information about the SIM
                    card used by the Device, mobile network information, your
                    Device’s operating system, the type of browser you use, or
                    your Device’s location and time zone setting (Device
                    Information);
                  </li>
                  <li>
                    data from your use of any other third-party application on
                    the Device or the Service Sites; and
                  </li>
                  <li>
                    details of your use of any of our Apps or your visits to any
                    of Our Service Sites; including, but not limited to, traffic
                    data, location data, weblogs and other communication data
                    (Log Information).
                  </li>
                </ul>
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">iii. Location information.</Typography>
              <Typography>
                We may also use GPS technology OR other location services to
                determine your current location. You can withdraw your consent
                to our collection, processing or use of this information at any
                time by logging out and uninstalling the App from your Device.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                iv. Information we receive from other sources (Third Party
                Information).
              </Typography>
              <Typography>
                Due to the nature of the Services which we provide, we are
                required to work with a number of third parties (including
                credit reference agencies and mobile network providers) and we
                may receive information about you from them.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                v. Unique application numbers.
              </Typography>
              <Typography>
                When you install or uninstall a Service containing a unique
                application number or when such a Service searches for automatic
                updates, that number and information about your installation,
                for example, the type of operating system, may be sent to us.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                vi. Third-Party Social Media data.
              </Typography>
              <Typography>
                Should you decide to register through or otherwise grant us
                access to a Third-Party Social Media Service, such as Facebook
                or Whatsapp, We may collect Personal data that is already
                associated with your Third-Party Social Media Service’s account,
                such as your name, your email address, your activities or your
                contact list associated with that account.
              </Typography>

              <Typography>
                You may also have the option of sharing additional information
                with the Company through your Third-Party Social Media Service’s
                account. If you choose to provide such information and Personal
                Data, during registration or otherwise, you are giving the
                Company permission to use, share, and store it in a manner
                consistent with this Privacy Policy.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                B. Tracking and cookies
              </Typography>
              <Typography>
                We may use mobile tracking technologies and/or website cookies
                to distinguish you from other users of the App, App Site, or
                Service Sites. This helps us to provide you with a good
                experience when you use the App or browse any of the Service
                Sites and also allows us to improve the App and Our Service
                Sites.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                C. Uses made of the information
              </Typography>
              <Typography>
                We may associate any category of information with any other
                category of information and will treat the combined information
                as personal data in accordance with this Policy for as long as
                it is combined.
              </Typography>

              <Typography>
                Information collected by us shall be used for the purpose of
                determining whether or not to provide a loan to the customer,
                the amount of such loan and the terms and conditions applicable
                to such loan.
              </Typography>

              <Typography>
                Save in compliance with an order of the Court, Arbitral Panel,
                Tribunal, Regulatory Directive or Order or any other legal or
                regulatory obligation, we do not disclose information about
                identifiable individuals to other parties, but we may provide
                them with anonymous aggregate information about our users (for
                example, we may inform them that 500 men aged under 30 have
                applied for a loan on any given day).
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                D. Disclosure of your information
              </Typography>
              <Typography>
                We may disclose some or all of the data we collect from you when
                you download or use the App to credit reference bureaus.
              </Typography>

              <Typography>
                We may disclose your personal information to any member of our
                group, which means our subsidiaries, affiliates, our holding
                company and its subsidiaries.
              </Typography>

              <Typography>
                <ul>
                  <li>
                    In the event that we sell or buy any business or assets, in
                    which case we may disclose your personal data to the
                    prospective seller or buyer of such business or assets
                  </li>
                  <li>
                    if Sava or substantially all of its assets are acquired by a
                    third party, in which case personal data held by it about
                    its customers will be one of the transferred assets;
                  </li>
                  <li>
                    if we are under a duty to disclose or share your personal
                    data in order to comply with any legal or regulatory
                    obligation or request; and/or
                  </li>
                  <li>
                    in order to: enforce our Terms and Conditions and other
                    agreements or to investigate potential breaches; report
                    defaulters to any credit bureau; or for the purpose of
                    publishing statistics relating to the use of the App, in
                    which case all information will be aggregated and made
                    anonymous.
                  </li>
                </ul>
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                E. Where We store your personal data
              </Typography>
              <Typography>
                The data that we collect from you may be transferred to, and
                stored at, a destination outside Tanzania. It may also be
                processed by staff operating outside Tanzania, who work for us
                or for one of our suppliers. These staff members may be engaged
                in the fulfillment of your requests. By submitting your personal
                data, you agree to the collection, transfer, storing or
                processing of your personal data in the manner set out above. We
                will take all steps reasonably necessary to ensure that your
                data is treated, stored and processed securely and in accordance
                with this privacy Policy.
              </Typography>

              <Typography>
                Where we have given you (or where you have chosen) a password
                that enables you to access certain parts of Our Service Sites,
                you are responsible for keeping this password confidential. We
                ask you not to share a password with anyone. Unfortunately, the
                transmission of information via the internet is not completely
                secure. Although we will do our best to protect your personal
                data, we cannot guarantee the security of your data transmitted
                to Our Service Sites; any transmission is at your own risk. Once
                we have received your information, we will use strict procedures
                and security features to try to prevent unauthorized access.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                F. Google API Disclosure
              </Typography>
              <Typography>
                Sava’s use of information received from Google APIs will adhere
                to Google API Services User Data Policy, including the Limited
                Use requirements.
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                G. Changes to privacy policy
              </Typography>
              <Typography>
                Any changes we may make to this Policy in the future will be
                posted on this page and, where appropriate, notified to you when
                you next start the App or log onto one of the Service Sites. The
                new terms may be displayed on-screen and you may be required to
                read and accept them to continue your use of the App or the
                Services. In any event, by continuing to use the App or any
                Services after the posting of any changes, you confirm your
                continuing acceptance of this Policy together with such changes,
                and your consent to the terms set out therein
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                H. Contact Us
              </Typography>

              <Typography>
                If you have any questions about this Privacy Policy, You can
                contact us:
              </Typography>

              <Typography>
                <strong>By email:</strong> info@sava.co.tz
              </Typography>

              <Typography>
                <strong>By visiting this page on our website:</strong>{" "}
                https://sava.co.tz/privacy-policy
              </Typography>

              <Typography>
                <strong>By phone number:</strong> +255 672 600 151
              </Typography>
            </Box>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
